<template>
  <div class="carrier-avatar-and-name flex flex-gap-1 align-items-center">
    <CarrierAvatar :carrier="internalCarrier" size="normal" />
    <div>
      <div class="carrier-name">{{ displayText }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, Ref, ref, toRefs, watch } from 'vue';

import { Loadable } from '@rygen/rygen-ui/model';

import { Carrier } from '@/model';
import { useCarrierStore } from '@/stores/Carrier';

import CarrierAvatar from '@rygen/rygen-ui/components/carrier/CarrierAvatar.vue';

const props = defineProps<{ name?: string; scac?: string }>();
const { scac, name } = toRefs(props);

const { loadCarrierByScac } = useCarrierStore();

const carrierLoadable: Ref<Loadable<Carrier>> = ref({ loading: false });

const displayText = computed(() => {
  const nameVal = name?.value;
  const scacVal = scac?.value;
  if (nameVal && scacVal) {
    return `${nameVal} (${scacVal})`;
  } else if (nameVal) {
    return nameVal;
  } else if (scacVal) {
    return scacVal;
  }
  return '-';
});

const internalCarrier = computed(() => {
  return new Carrier({
    name: name.value,
    scac: scac.value,
    ...carrierLoadable.value.data,
  });
});

watch(
  scac,
  (newScacVal) => {
    if (newScacVal) {
      carrierLoadable.value = loadCarrierByScac(newScacVal);
    } else {
      carrierLoadable.value = { loading: false };
    }
  },
  { immediate: true },
);
</script>

<style>
.carrier-avatar-and-name {
  .carrier-name {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
</style>
